import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    window.location.href = 'https://checkout.ebookpoint.shop/cart/59589844435025:1';
  };
  return <AnimatePresence data-id="element-241">
      {show && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden" data-id="element-242">
          <div className="bg-white border-t-4 border-emerald-600 shadow-2xl p-4" data-id="element-243">
            <div className="flex items-center justify-between gap-4" data-id="element-244">
              <div data-id="element-245">
                <div className="text-sm text-slate-500 line-through" data-id="element-246">
                  $59.990
                </div>
                <div className="text-2xl font-bold text-emerald-600" data-id="element-247">
                  $19.990
                </div>
              </div>
              <button onClick={handleClick} className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold px-6 py-3 rounded-xl shadow-lg flex-shrink-0" data-id="element-248">
                Comprar ahora
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}